import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { MediaQuery as MQ } from '../../../shared/media-query';
import { Suspense, lazy } from 'preact/compat';
const DatePicker = lazy(
    () => import(/* webpackChunkName: "date-picker" */ '../../../app/components/date-picker')
);
import TextLinks from './shared/daily-text-links';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            date: props.date || dayjs().format('YYYY-MM-DD'),
        };

        props.requireHexagram(this.state.date);

        if (this.props.base_url.match(/vip/) && props.route != 'everyone' && props.route != 'login') {
            props.routeTo('you');
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.logged_in != this.props.logged_in) {
            if (nextProps.logged_in == false && this.props.base_url.match(/vip/)) { //user logs out on VIP page
                document.location.href = this.props.base_url.replace(/\/vip/, '');
                return false;
            } else if (
                nextProps.logged_in == true
                &&
                nextProps.user.subscriptions
                &&
                nextProps.user.subscriptions.vip
                &&
                !this.props.base_url.match(/vip/)
            ) { //user logs in on non-VIP page
                document.location.href = `/vip${this.props.base_url}`;
                return false;
            }

            return true;
        }

        if (nextState.date != this.state.date) {
            return true;
        }

        if (nextProps.hexagram != this.props.hexagram) {
            return true;
        }

        if (nextProps.route != this.props.route) {
            return true;
        }

        return false;
    }

    render({ hexagram, base_url, logged_in, route, trackEvent }, { date }) {
        const vip = base_url.match(/vip/);

        if (hexagram) {
            const hex = logged_in && route != 'everyone' ? hexagram.you : hexagram.everyone;

            if (vip) {
                return (
                    <daily-hexagram base_url={base_url} date={date}>
                        {this.renderVIP(hex)}
                    </daily-hexagram>
                );
            }

            const buttontitle = logged_in ? 'GET YOUR DAILY I CHING READING' : 'GET YOUR DAILY HEXAGRAM';
            const buttonga4 = logged_in ? 'GetIChingReading' : 'GetDailyHexagram';

            if (hex && hex.title) {
                return (
                    <daily-hexagram date={date} base_url={base_url}>
                        <row className='has-margin-20-bottom'>
                            <column className='is-1'>
                                <Suspense fallback={<div className='skeleton' />}>
                                    <DatePicker
                                        url={`${base_url || '/daily-hexagram'}/:date`}
                                        page='hexagram'
                                        mindate={dayjs().subtract(90, 'day').format('YYYY-MM-DD')}
                                        maxdate={dayjs().add(2, 'day').format('YYYY-MM-DD')}
                                        date={dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                                        autosubmit='true'
                                    />
                                </Suspense>
                            </column>
                            <column className='is-11'>
                                <TextLinks
                                    date={date}
                                    base_url={base_url || '/daily-hexagram'}
                                />
                            </column>
                        </row>
                        <row>
                            <column className='is-4 is-5-mobile has-padding-30-right has-padding-20-right-mobile'>
                                <a
                                    href={`/i-ching/hexagrams/${hex.title.toLowerCase().replace(/\s+/g, '-')}`}
                                    onClick={() => trackEvent([
                                        'Click',
                                        `DailyHexagram:${hex.index}-${hex.title}`,
                                    ])}
                                >
                                    <img src={hex.image} height='401' width='267' alt={hex.title} />
                                </a>
                            </column>
                            <column className='is-8 is-7-mobile'>
                                <h1 className='has-margin-15-bottom'>Hexagram of<br />the Day</h1>
                                <h3 className='has-weight-400'>
                                    {logged_in ? 'For You: ' : 'For Everyone: '}
                                    <a
                                        href={`/i-ching/hexagrams/${hex.title.toLowerCase().replace(/\s+/g, '-')}`}
                                        onClick={() => trackEvent([
                                            'Click',
                                            `DailyHexagram:${hex.index}-${hex.title}`,
                                        ])}
                                    >
                                        #{hex.index}: {hex.title}
                                    </a>
                                </h3>
                                <a
                                    href={logged_in ? '/readings-reports/i-ching/free' : '#login-signup'}
                                    className='button button-pink-alternate is-pill has-margin-10-top'
                                    onClick={() => trackEvent([
                                        'Click',
                                        `DailyHexagram:${buttonga4}`,
                                    ])}
                                >
                                    {buttontitle}
                                </a>
                            </column>
                        </row>
                        <p
                            className='has-margin-30-top'
                            dangerouslySetInnerHTML={{ __html: `
                                <b>${dayjs(hex.date).format('M.D.YY')}:</b>
                                ${hex.body.join('<br /><br />')}
                            ` }}
                        />
                    </daily-hexagram>
                );
            }
        }

        return (<daily-hexagram date={date} base_url={base_url} />);
    }

    renderVIP = (hex) => {
        if (MQ.isMobile()) {
            /* eslint-disable react/jsx-closing-bracket-location */
            return (
                <daily-hexagram-mobile>
                    <row className='is-aligned-center'>
                        <column className='is-1'>
                            <Suspense fallback={<div className='skeleton' />}>
                                <DatePicker
                                    url={`${this.props.base_url || '/daily-hexagram'}/:date`}
                                    page='hexagram'
                                    mindate={dayjs().subtract(90, 'day').format('YYYY-MM-DD')}
                                    maxdate={dayjs().add(2, 'day').format('YYYY-MM-DD')}
                                    date={dayjs(this.state.date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                                    autosubmit='true'
                                />
                            </Suspense>
                        </column>
                        <column className='is-11 has-padding-20-left-mobile'>
                            <div className='daily-links'>
                                <a
                                    href='#everyone'
                                    className={this.props.route == 'everyone' ? 'selected' : ''}
                                >
                                    FOR EVERYONE
                                </a>
                                <a
                                    href='#you'
                                    className={this.props.route != 'everyone' ? 'selected' : ''}
                                >
                                    FOR YOU
                                </a>
                                {this.renderHoroscopeLink()}
                            </div>
                        </column>
                    </row>
                    <h1>Hexagram of the Day</h1>
                    <a href={`/i-ching/hexagrams/${hex.title.toLowerCase().replace(/\s+/g, '-')}`}>
                        #{hex.index}: {hex.title}
                    </a>
                    <a href={`/i-ching/hexagrams/${hex.title.toLowerCase().replace(/\s+/g, '-')}`}>
                        <img src={hex.image} height='401' width='267' alt={hex.title} />
                    </a>
                    <p dangerouslySetInnerHTML={{ __html: `
                        <b>${dayjs(hex.date).format('M.D.YY')}:</b>
                        ${hex.body}
                    ` }} />
                </daily-hexagram-mobile>
            );
            /* eslint-enable react/jsx-closing-bracket-location */
        }

        return (
            <daily-hexagram-non-mobile>
                <div className='daily-hexagram'>
                    <a href={`/i-ching/hexagrams/${hex.title.toLowerCase().replace(/\s+/g, '-')}`}>
                        <img src={hex.image} height='401' width='267' alt={hex.title} />
                    </a>
                    <small>
                        <a href={`/i-ching/hexagrams/${hex.title.toLowerCase().replace(/\s+/g, '-')}`}>
                            #{hex.index}: {hex.title}
                        </a>
                    </small>
                </div>
                <row>
                    <column className='is-1'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <DatePicker
                                url={`${this.props.base_url || '/daily-hexagram'}/:date`}
                                mindate={dayjs().subtract(90, 'day').format('YYYY-MM-DD')}
                                maxdate={dayjs().add(2, 'day').format('YYYY-MM-DD')}
                                date={dayjs(this.state.date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                                autosubmit='true'
                                page='hexagram'
                            />
                        </Suspense>
                    </column>
                    <column className='is-11 has-padding-10-left-mobile'>
                        <TextLinks
                            date={this.state.date}
                            base_url={this.props.base_url || '/daily-hexagram'}
                        />
                    </column>
                </row>
                <h1>Hexagram of<br />the Day</h1>
                <div className='daily-links'>
                    <a href={this.props.route == 'everyone' ? '#you' : '#everyone'}>
                        {this.props.route == 'everyone' ? 'For You' : 'For Everyone'}
                    </a>
                    <a
                        href='/readings-reports/i-ching/free'
                        onClick={() => this.props.trackPromo(['HOD', 'I-Ching'])}
                    >
                        Get Your Daily I Ching Reading
                    </a>
                </div>
                <br />
                <p
                    className='has-margin-10-top'
                    dangerouslySetInnerHTML={{ __html: `
                        <b>${dayjs(hex.date).format('M.D.YY')}:</b>
                        ${hex.body}
                    ` }}
                />
            </daily-hexagram-non-mobile>
        );
    }

    renderHoroscopeLink = () => {
        if (!this.props.base_url.match(/vip/)) {
            return (<a href='/readings-reports/subscription/vip-membership'>VIP Horoscopes</a>);
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    hexagram: state.hexagram,
    logged_in: state.user && state.user.logged_in,
    route: state.route,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    requireHexagram: (date) => dispatch({ type: 'hexagram:require', payload: date }),
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
